// extracted by mini-css-extract-plugin
export default {"collapseTrigger":"BaseTableCollapseTrigger_collapseTrigger__Axxq8"};